<template>
    <div class="card">
        <div class="flex-column p1">
            <div class="card_image">
  
                <el-image :src="GetImagePath" :preview-src-list="[GetImagePath]" fit="cover"
                    style="width: 100%; height: 100%" />
            </div>
            <div class="box_con  ">
                <div class="flex-row middle p1">
                    <div class="flex-row left wf f16b">{{ value.Name }}</div>
                </div>
                <div class="flex-row end wrap list-half   border-top divider">
                    <div class="wf p1 pointer" v-if="IsDetail" @click="OnGoDetail">
                        <a class="button" href="javascript:void(0)">查看详情</a>
                    </div>
                    <div class='wf p1 pointer' v-if="!GetDisabled('modify')" @click="OnModify">
                        <a class="button" href="javascript:void(0)">编辑</a>
                    </div>
                    <div class="wf p1 pointer" v-if="!GetDisabled('del')" @click="OnDelete">
                        <a class="button" href="javascript:void(0)">删除</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import base from "matrix.node.ui/libs/panels/base.js";
export default {
    props: {
        config: Object,
        value: Object,
        index: Number,
        role: String,
        roleField: String,
        name: String,
    },
    mixins: [base],
    data() {
        return { IsModify: false, IsDelete: false, };
    },
    computed: {
        Config() {
            return Object.assign(
                { EventName: this.name ? this.name : "TypeEvent", IsDark: false },
                this.config
            );
        },
        SiteUrl() {
            return this.$matrix.Config.ImageSite;
        },
        IsDetail() {
            if (this.config.DetailView) return true
            return false
        },
        GetImagePath() {
            return this.SiteUrl + this.value.Image || this.SiteUrl + this.value.FaceImage
        }


    },
    methods: {

        OnEvent(e) {
            this.$emit("event", e);
        },
        onGoDetail() {
            let View = this.config.DetailView;
            if (!View) return this.$matrix.ShowError("未配置详情视图");
            this.$emit("goview", {
                View: View,
                ViewType: "详情",
                Data: this.value,
                Role: this.config.Role,
                RoleField: this.config.RoleField,
            });
        },
    },
};
</script>

<style scoped>
.card {
    width: 20%;
    overflow: hidden;
    margin-bottom: 20px;
}

.card_image {
    height: 240px;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    overflow: hidden;
}

.box_con {
    background: #f7f8fa;
}

.button {
    font-size: 14px;
    color: #409eff;
}

.mt5 {
    margin-top: 5px;
}

.border-top {
    border-top: 1px solid #ebebeb;
}


.divider .wf {
    position: relative;
}

.divider .wf::after {
    content: " ";
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    border-right: 1px solid #ebebeb;
    width: 1px solid #ebebeb;
}

.divider .wf:last-child::after {
    display: none;
}
</style>